import "./PageLoader.css";

/**
 * PageLoader — Minimal full-area loading indicator.
 *
 * Usage:
 *   if (loading) return <PageLoader />;
 *   <PageLoader tip="Loading riders..." />
 */
export default function PageLoader({ tip = "Loading" }) {
  return (
    <div className="page-loader">
      <div className="page-loader-spinner" />
      <span className="page-loader-tip">{tip}</span>
    </div>
  );
}
